import React from 'react';

/**
 * Full “Resident of Israel” definition (Exhibit C) for Israeli Tax Status tooltips.
 */
const IsraeliResidentOfIsraelDefinition = () => (
  <div style={{ width: '100%' }} id="exhibit-c">
    <h4 style={{ textAlign: 'center' }}>
      <b>
        <u>Definition</u>
      </b>
    </h4>
    <h4 style={{ textAlign: 'center' }}>
      <b>Resident of Israel</b>
    </h4>
    <p>
      <u>Resident of Israel.</u> Section 1 of the Israeli Income Tax Ordinance
      [New Version], 1961 defines a &quot;resident of Israel&quot; or a
      &quot;resident&quot; as follows:
    </p>

    <div className="left-margin-push">
      <p>
        (a) with respect to an individual - a person whose center of vital
        interests is in Israel; for this purpose the following provision will
        apply:
      </p>
      <div className="left-margin-push">
        <p>
          (i) in order to determine the center of vital interests of an
          individual, account will be taken of the individual&apos;s family,
          economic and social connections, including:
        </p>
        <div className="left-margin-push">
          <p>(1) place of permanent home;</p>
          <p>
            (2) place of residential dwelling of the individual and the
            individual&apos;s immediate family;
          </p>
          <p>
            (3) place of the individual&apos;s regular or permanent occupation
            or the place of his permanent employment;
          </p>
          <p>
            (4) place of the individual&apos;s active and substantial economic
            interests;
          </p>
          <p>
            (5) place of the individual&apos;s activities in organizations,
            associations and other institutions;
          </p>
        </div>
        <p>
          (ii) the center of vital interests of an individual will be deemed
          to be in Israel if:
        </p>
        <div className="left-margin-push">
          <p>
            (1) the individual was present in Israel for 183 days or more in the
            tax year; or
          </p>
          <p>
            (2) the individual was present in Israel for 30 days or more in the
            tax year, and the total period of the individual&apos;s presence in
            Israel that tax year and the two previous tax years is 425 days or
            more;
          </p>
          <p>
            (3) for the purposes of this provision, &quot;day&quot; includes a
            part of a day.
          </p>
        </div>
        <p>
          (iii) the presumption in subparagraph (ii) may be rebutted either by
          the individual or by the assessing officer.
        </p>
      </div>
      <p>
        (b) with respect to a body of persons - a body of persons which meets
        one of the following:
      </p>
      <div className="left-margin-push">
        <p>(i) it was incorporated in Israel;</p>
        <p>
          (ii) the control and management of its business are exercised in
          Israel, except for a body of persons, the business of which is
          controlled and managed in Israel by an individual who became an Israel
          resident for the first time or who became a veteran returning
          resident, as said in section 14(a) and ten years have not yet passed
          since he became an Israel resident as aforesaid, or by any person on
          his behalf, on condition that that body of persons would not be an
          Israel resident if the control and management of its business were not
          by said individual or a person on his behalf, unless the body of
          persons requested otherwise.
        </p>
      </div>
    </div>
  </div>
);

export default IsraeliResidentOfIsraelDefinition;
